__turbopack_context__.v({
  "active": "_1vxMca_active",
  "dropdown": "_1vxMca_dropdown",
  "dropdown-container": "_1vxMca_dropdown-container",
  "dropdown-options": "_1vxMca_dropdown-options",
  "native-dropdown": "_1vxMca_native-dropdown",
});
